import { TOPICS } from '../data/topics.js';

const SCALE = 0.13;

export function createMinimap(islandObjects, camera, getActiveTopic, onFocus) {
  const miniCanvas = document.querySelector('#minimap canvas');
  const ctx = miniCanvas.getContext('2d');

  miniCanvas.addEventListener('click', e => {
    const rect = miniCanvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const W = miniCanvas.clientWidth, H = miniCanvas.clientHeight;
    const wx = (x - W / 2) / SCALE;
    const wz = (y - H / 2) / SCALE;
    let nearest = null, nd = Infinity;
    islandObjects.forEach(o => {
      const d = Math.hypot(o.project.pos[0] - wx, o.project.pos[2] - wz);
      if (d < nd) { nd = d; nearest = o; }
    });
    if (nearest && nd < 90) onFocus(nearest.project.id);
  });

  function draw(yaw) {
    const dpr = window.devicePixelRatio;
    if (miniCanvas.width !== miniCanvas.clientWidth * dpr) {
      miniCanvas.width = miniCanvas.clientWidth * dpr;
      miniCanvas.height = miniCanvas.clientHeight * dpr;
    }
    const W = miniCanvas.clientWidth, H = miniCanvas.clientHeight;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, W, H);
    const cx = W / 2, cy = H / 2;

    const grad = ctx.createRadialGradient(cx, cy, 10, cx, cy, W / 1.5);
    grad.addColorStop(0, 'rgba(255, 220, 160, 0.05)');
    grad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, W, H);

    const activeTopic = getActiveTopic();
    islandObjects.forEach(o => {
      const match = activeTopic === 'all' || o.project.topic === activeTopic;
      const x = cx + o.project.pos[0] * SCALE;
      const y = cy + o.project.pos[2] * SCALE;
      ctx.beginPath();
      ctx.fillStyle = TOPICS[o.project.topic].hex;
      ctx.globalAlpha = match ? 0.95 : 0.18;
      ctx.arc(x, y, o.project.featured ? 4.5 : 3.5, 0, Math.PI * 2);
      ctx.fill();
      if (o.project.featured && match) {
        ctx.globalAlpha = 0.5;
        ctx.beginPath();
        ctx.arc(x, y, 7, 0, Math.PI * 2);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    });

    const cxp = cx + camera.position.x * SCALE;
    const cyp = cy + camera.position.z * SCALE;
    const half = camera.fov * Math.PI / 360;
    ctx.beginPath();
    ctx.moveTo(cxp, cyp);
    ctx.lineTo(cxp + Math.sin(yaw - half) * 28, cyp + Math.cos(yaw - half) * -28);
    ctx.lineTo(cxp + Math.sin(yaw + half) * 28, cyp + Math.cos(yaw + half) * -28);
    ctx.closePath();
    ctx.fillStyle = 'rgba(250, 242, 221, 0.18)';
    ctx.fill();

    ctx.beginPath();
    ctx.fillStyle = '#faf2dd';
    ctx.arc(cxp, cyp, 3.2, 0, Math.PI * 2);
    ctx.fill();
  }

  return { draw };
}
